const ResourceVideo = () => import('@/views/resource/video')
const ResourceAttraction = () => import('@/views/resource/attraction')
const ResourceMusic = () => import('@/views/resource/music')

/**
 * 资源展示页 路由配置
 */
export default [

    {
        path: '/r/video/:id',
        name: 'ResourceVideo',
        props: true,
        component: ResourceVideo,
        meta: {
            title: '视频资源'
        }
    },
    {
        path: '/r/video/list',
        name: 'ResourceVideoList',
        component: () => import('@/views/resource/video/list.vue'),
        meta: {
            title: '视频资源'
        }
    },
    {
        path: '/r/attraction/:id',
        name: 'ResourceAttraction',
        props: true,
        component: ResourceAttraction,
        meta: {
            title: '文博场馆详情'
        }
    },
    // 图书介绍页
    {
        path:'/r/book/:id',
        name: 'ResourceBook',
        props: true,
        component: () => import("@/views/resource/book/index"),
        meta: {
            title: "数字图书",
        }
    },
    // 图书详情页
    {
        path:'/r/book/:id/pdf',
        name: 'ResourceBookPDF',
        props: true,
        component: () => import("@/views/resource/book/pdf"),
        meta: {
            title: "数字图书",
        }
    },
    // PS:不要问我为啥有 audio和music两个文件夹，懒得合并了而已
    // 数字听书&音乐 介绍页
    {
        path: '/r/music/:id',
        name: 'ResourceMusic',
        props: true,
        component: () => import('@/views/resource/audio'),
        meta: {
            title: '数字听书'
        }
    },
    // 音乐 播放页
    {
        path: '/r/music/:id/play',
        name: 'ResourceMusicPlay',
        props: true,
        component: ResourceMusic,
        meta: {
            title: '音乐视听'
        }
    },
    // 富文本详情页
    {
        path:'/r/article/:id',
        name: 'ResourceArticle',
        props: true,
        component:() => import("@/views/resource/article"),
        meta: {
            title: '图文资源',
        },
    },
    // 富文本列表页
    {
        path:'/r/article/list/:id',
        name: 'ResourceArticleList',
        props: true,
        component:() => import("@/views/resource/article/list"),
        meta: {
            title: '图文资源列表',
        },
    },
    // 图片专辑详情页
    {
        path:'/r/img/:id',
        name: 'ResourceImg',
        props: true,
        component:() => import("@/views/resource/img"),
        meta: {
            title: '图片专辑',
        },
    }
]
